import { Button } from "@mui/material";
import React from "react";
import { DayliPlanContext } from "../context/dayliPlanContext";
import IDayliPlan from "../interface/iDayliPlan";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";

const ExportCsvButton = (): React.JSX.Element => {
  const {
    isLoading,
    dayliPlan,
    exportToCsv,
  }: {
    isLoading: boolean;
    dayliPlan: IDayliPlan;
    exportToCsv: () => void;
  } = React.useContext(DayliPlanContext);

  return (
    <React.Fragment>
      {dayliPlan.appointments.length > 0 && (
        <Button
          disabled={isLoading}
          sx={{
            height: "100%",
          }}
          onClick={exportToCsv}
          variant="contained"
          color="primary"
        >
          <LocalPrintshopOutlinedIcon />
        </Button>
      )}
    </React.Fragment>
  );
};

export default ExportCsvButton;
